<template>
  <div
    :id="name"
    class="content-none"
  >
    <div
      v-if="isEditor"
      class="content-none-placeholder"
    >
      <div class="title">{{ name }}
        <template v-if="filestore">
        | File Store: {{ filestore.filestoreID }}
        </template>
      </div>
      <template v-if="widgetType === 'none'">
        <p class="hint">
          Please activate the
          Content Creator
          to add content.
        </p>
      </template>
      <template v-else>
        <p class="hint">
          The {{ widgetType }} layout selected has misconfigured settings and will not be displayed.
        </p>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'content-none',
    props: {
      name: {
        type: String,
        required: true
      },
      filestore: {
        type: [Object, String],
        required: false
      },
      widget: {
        type: [Object, String],
        required: false,
        default: () => ({})
      },
      permissions: {
        type: Object,
        required: false,
        default: () => ({})
      }
    },
    computed: {
      isEditor: function() {
        return (this.permissions.devel || this.permissions.edit || this.permissions.editMenu)
      },
      widgetType() {
        return this.widget.widgetType
      },
    }
  }
</script>

<style scoped lang="scss">

  .content-none-placeholder {
    min-height: 150px;
    border: 1px solid #84848442;
    background-color: #fff0bd;
    padding: 1em;
    box-shadow: 1px 1px 1em rgba(0,0,0,0.1);
    text-align: center;
    font-size: 1em;
    color: #000;

    .title {
      font-weight: bold;
      margin-bottom: 1em;
      border: 1px solid rgba(0,0,0,0.3);
      display: inline-block;
      border-radius: 1em;
      padding: 0 1em;
      background: #ffffff85;
    }

    .hint {
      font-style: italic;
    }
  }
</style>
